import { Component } from '@angular/core';
import { TreeComponent } from '../tree.component';
import { TreeService } from '../tree.service';
import { GermplasmTreeService } from './germplasm-tree.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { TreeNode as PrimeNgTreeNode } from 'primeng/api';

@Component({
    selector: 'jhi-germplasm-tree-table',
    templateUrl: '../tree-table.component.html',
    providers: [{ provide: TreeService, useClass: GermplasmTreeService }]
})
export class GermplasmListTreeTableComponent extends TreeComponent {

    title = 'global.browse.for.list';

    constructor(public service: TreeService,
                public activeModal: NgbActiveModal,
                public alertService: AlertService,
                public translateService: TranslateService,
                public modalService: NgbModal) {
        super(service, activeModal, alertService, translateService, modalService);
        this.selectionMode = 'multiple';
    }

    onMoveSuccess(draggedNode: PrimeNgTreeNode, res: any) {
        draggedNode.data.isLocked = res.isLocked;
    }

}
